import { render, staticRenderFns } from "./ApprovalSpec.vue?vue&type=template&id=2da9e4d8"
import script from "./ApprovalSpec.vue?vue&type=script&lang=js"
export * from "./ApprovalSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports